import React from 'react';
import './GradientBorder.scss';

const GradientBorder = ({ name, children }: { name: string; children: React.ReactNode }) => {
  return <div className={`border-component ${name}`}>{children}</div>;
};

export default GradientBorder;
